import React, { useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function ConfirmCancelRequestModal({
  cancelModal,
  request,
  fetchData,
}) {
  const { user } = useAuthContext();
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    try {
      setIsLoading(true); // Start loading

      const cancelBookingResponse = await axios.delete(
        `${ApiConnectionString}/api/Booking/${request.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (cancelBookingResponse.status == 200) {
        setComplete(true); // Set completion state
      }
    } catch (error) {
      console.error("Error canceling booking:", error); // Handle any errors
      // Optionally, set an error state or display an error message to the user
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />

          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Booking Canceled</p>
            </div>

            <p>
              {request.viewAppUser.username}'s booking has been successfully
              canceled.
            </p>

            <div className="send-modal-footer">
              <button
                onClick={() => {
                  fetchData();
                  cancelModal();
                }}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Confirm Cancel Booking Request
              </p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <table>
              <tbody>
                <tr>
                  <td className="red-text">
                    <strong>User:</strong>
                  </td>
                  <td>{request.viewAppUser.username}</td>
                </tr>
                <tr>
                  <td className="red-text">
                    <strong>Event:</strong>
                  </td>
                  <td>{request.viewEvent.name} at</td>
                </tr>
                <tr>
                  <td className="red-text">
                    <strong>Time:</strong>
                  </td>
                  <td>
                    {request.viewEvent.timeIn} - {request.viewEvent.timeOut}
                  </td>
                </tr>
                <tr>
                  <td className="red-text">
                    <strong>Date:</strong>
                  </td>
                  <td>{new Date(request.date).toLocaleDateString()}</td>
                </tr>
              </tbody>
            </table>

            <p>
              {request.viewAppUser.username} has requested to cancel this
              booking for their profile.
            </p>

            <p>Press confirm to allow the cancellation of this booking.</p>

            <div className="send-modal-footer">
              <button
                className="saveChanges-button mx-3"
                onClick={handleConfirm}
              >
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
